export class Order {
  public page: number;
  public pageDefault: number;
  public limit: number;
  public search: string;
  public orderBy: string;
  public isAsc: boolean;
  public firstDate: string;
  public lastDate: string;
  public type: number;
  public typeCode: number;

  constructor(
    page = 1,
    pageDefault = 1,
    limit = 1,
    search = "",
    orderBy = "",
    isAsc = false,
    firstDate = "",
    lastDate = "",
    type = 0,
    typeCode = 0,
  ) {
    this.page = page;
    this.pageDefault = pageDefault;
    this.limit = limit;
    this.search = search;
    this.orderBy = orderBy;
    this.isAsc = isAsc;
    this.firstDate = firstDate;
    this.lastDate = lastDate;
    this.type = type;
    this.typeCode = typeCode;
  }
}
